module.exports = "/assets/data/abef471f2e24abf657275f57bba7ea32-CF23.data.json";